import { XIcon } from 'lucide-react'
import type { ReactNode } from 'react'

import { Button } from '@/components/ui/button'

interface AgentNodeDrawerHeaderProps {
  isEntryPoint?: boolean
  isMobile: boolean
  onCancel: () => void
}

export const AgentNodeDrawerHeader = ({
  isEntryPoint,
  isMobile,
  onCancel,
}: AgentNodeDrawerHeaderProps): ReactNode => (
  <div className="agent-node-drawer-header flex items-center justify-between border-b px-6 py-4">
    <div>
      <h2 className="agent-node-drawer-title text-lg font-semibold">
        {isEntryPoint ? 'Edit Entry Point Agent' : 'Edit Agent'}
      </h2>
      <p className="agent-node-drawer-description text-sm text-muted-foreground">
        Configure the agent properties for this node in the workflow.
      </p>
    </div>
    {!isMobile && (
      <Button variant="ghost" size="icon" onClick={onCancel} className="agent-node-drawer-close">
        <XIcon className="size-4" />
      </Button>
    )}
  </div>
)

AgentNodeDrawerHeader.displayName = 'AgentNodeDrawerHeader'
